<template>
  <div class="status">
    <div class="top">
      <img src="../assets/img/notpass.png" alt="" srcset="" />
      <p v-show="audit_status == 2">审核中</p>
      <p v-show="audit_status == 3">审核不通过</p>
    </div>
    <div class="reason" v-show="audit_status == 3">
      <p>您的DJ审核未通过，请仔细查看未通过原因，修改信息后重新提交：</p>
      <p class="hl">{{ infoReviewMessage }}</p>
    </div>
    <div class="btn-content">
      <div class="add" @click="gotoEnter" v-show="audit_status == 3">修改信息</div>
      <div class="add disabled" v-show="audit_status == 2">修改信息</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(() => {
      this.myStatus();
    })
  },
  methods: {
    gotoEnter() {
      this.$router.push("/enter");
    },
    gotoWork() {
      this.$router.push("/work");
    },
    gotoAdd() {
      this.$router.push("/editsong");
    },
    //获取我的状态
    myStatus(cb) {
      this.api({
        apiName: "myStatus",
        methods: "GET",
        getData: {
          biz: "musician_author_dj",
        },
      }).then((res) => {
        console.log(res);
        const data = res.data;
        this.audit_status = data.audit_status
        this.infoReviewMessage = data.info.review_message
        if(this.audit_status != 2 && this.audit_status != 3) {
          this.$router.push('/home')
        }
      });
    },
  },
  data() {
    return {
      audit_status: 0,
      status: 1,
      infoReviewMessage: "",
      songReviewMessage: "",
      failed_content: [],
      total_content: 0,
      review_status: {
        0: "未提交审核",
        1: "审核中",
        2: "审核通过",
        3: "审核不通过",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.status {
  width: 100%;
  height: calc(100vh - 10px);
  background: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .top {
    text-align: center;
    img {
      margin-bottom: 20px;
    }
  }
  .reason {
    color: #888888;
    margin-top: 30px;
    width: 660px;
    text-align: center;
    p {
      line-height: 2;
    }
    .hl {
      color: #f86378;
    }
  }
  .btn-content {
    display: flex;
    width: 300px;
    justify-content: space-around;
    .add {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      background-color: #0090ff;
      color: #fff;
      cursor: pointer;
      margin-top: 40px;
    }
    .disabled {
      background-color: #888
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/view/Status.vue